import { render, staticRenderFns } from "./SigleSourceRelTable.vue?vue&type=template&id=de68064c&scoped=true&"
import script from "./SigleSourceRelTable.vue?vue&type=script&lang=js&"
export * from "./SigleSourceRelTable.vue?vue&type=script&lang=js&"
import style0 from "./SigleSourceRelTable.vue?vue&type=style&index=0&id=de68064c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de68064c",
  null
  
)

export default component.exports